(function () {
  if (window.PetOliveQuickAddInitialized) return;
  window.PetOliveQuickAddInitialized = true;

  document.addEventListener('submit', async function (event) {
    const form = event.target.closest('form[data-po-drawer-add]');
    if (!form) return;

    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;

    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    if (!button || button.disabled) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const formData = new FormData(form);
      formData.append('sections', drawer.getSectionsToRender().map(function (section) {
        return section.id;
      }));
      formData.append('sections_url', window.location.pathname);
      drawer.setActiveElement(button);

      const response = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || 'Could not add product');
      }

      drawer.classList.remove('is-empty');
      drawer.renderContents(data);
    } catch (error) {
      console.error(error);
      window.location.assign(window.routes.cart_url);
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }, true);
})();
